import { useState } from 'react';
import { ErrorNote } from '../components/ui';
import { useSession } from '../services/session';

function randomId(): string {
  return `dev-${Math.random().toString(36).slice(2, 8)}`;
}

/**
 * Production: players arrive from Hi5 Crew with a one-time launch ticket, so there is no
 * sign-up form. Development: a mock Crew identity form (enabled only when the server
 * reports devAuthEnabled, which it refuses to do in production).
 */
export default function LoginPage() {
  const config = useSession((s) => s.config);
  const bootError = useSession((s) => s.error);
  const devLogin = useSession((s) => s.devLogin);
  const [tenantId, setTenantId] = useState('dev-crew');
  const [crewUserId, setCrewUserId] = useState(randomId);
  const [nickname, setNickname] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<unknown>(null);

  return (
    <div className="screen">
      <main className="content narrow">
        <h1 className="logo">CHROMARBLE MATCH</h1>
        <ErrorNote error={bootError} />
        <section className="card">
          <h3>Hi5 Crew에서 시작하기</h3>
          <p className="muted small">
            Crew 채팅의 게임 초대 메시지나 게임 메뉴에서 열면 별도 가입 없이 바로 입장합니다.
          </p>
        </section>
        {config?.devAuthEnabled && (
          <form
            className="card"
            data-testid="dev-login"
            onSubmit={async (e) => {
              e.preventDefault();
              setBusy(true);
              setError(null);
              try {
                await devLogin(tenantId.trim(), crewUserId.trim(), nickname.trim());
              } catch (err) {
                setError(err);
              } finally {
                setBusy(false);
              }
            }}
          >
            <h3>개발용 Mock Crew 로그인</h3>
            <p className="muted small">개발 환경 전용입니다. 운영 환경에서는 서버가 이 기능을 거부합니다.</p>
            <label>
              Crew (테넌트) ID
              <input value={tenantId} onChange={(e) => setTenantId(e.target.value)} required maxLength={64} name="tenantId" />
            </label>
            <label>
              Crew 사용자 ID
              <input value={crewUserId} onChange={(e) => setCrewUserId(e.target.value)} required maxLength={64} name="crewUserId" />
            </label>
            <label>
              닉네임
              <input value={nickname} onChange={(e) => setNickname(e.target.value)} required maxLength={20} name="nickname" autoComplete="nickname" />
            </label>
            <button className="btn" type="submit" disabled={busy} data-testid="dev-login-submit">
              {busy ? '로그인 중…' : '입장'}
            </button>
            <ErrorNote error={error} />
          </form>
        )}
      </main>
    </div>
  );
}
